import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/card/Card'
import { CircleMetrics } from 'components/circleMetrics/CircleMetrics'
import { EmptyList } from 'components/emptyList/EmptyList'
import { Spinner } from 'components/spinner/Spinner'
import { colors } from 'styles/colors'
import './enrollmentRecap.scss'

interface EnrollmentRecapProps {
    loading: boolean
    error: string
    sourceCounts: Record<string, number>
}

const DEFAULT_SOURCES = ['CONNECT', 'SIMPLE_ENROLLMENT']
const SOURCE_COLORS = [colors.primary, colors.blue, colors.orange, colors.purple]

export const EnrollmentRecap = ({
    loading,
    error,
    sourceCounts
}: EnrollmentRecapProps) => {
    const { t } = useTranslation()

    const sourceLabel = (source: string) =>
        t(`enrollmentRecap.sources.${source}`, {
            defaultValue: source
        })

    const sources = Array.from(
        new Set([...DEFAULT_SOURCES, ...Object.keys(sourceCounts)])
    )
    const metrics = sources.map((source, i) => ({
        label: sourceLabel(source),
        value: sourceCounts[source] ?? 0,
        color: SOURCE_COLORS[i % SOURCE_COLORS.length]
    }))

    return (
        <Card className="enrollment-recap-card" shadow>
            <h2 className="enrollment-recap--title">
                {t('enrollmentRecap.title')}
            </h2>
            {loading && <Spinner size="40" />}
            {!loading && error && (
                <EmptyList message={t('enrollmentRecap.error')} />
            )}
            {!loading && !error && <CircleMetrics metrics={metrics} />}
        </Card>
    )
}
